/**
 * Rutas públicas vs protegidas para el guard de sesión en cliente.
 * Con `output: 'export'` (Firebase Hosting) no corre middleware de Next; la misma
 * lógica vive en `AlumniSessionRouteGuard` + Firebase Auth.
 */
export const LOGIN_PATH = '/login'
export const DASHBOARD_PATH = '/dashboard'

export function isPublicPath(pathname: string): boolean {
	if (pathname === '/' || pathname === LOGIN_PATH || pathname === '/recuperar-contrasena' || pathname === '/recoverPassword') {
		return true
	}
	return false
}

export function isProtectedPath(pathname: string): boolean {
	if (pathname === '/activacion-mfa') return true
	if (pathname === DASHBOARD_PATH || pathname.startsWith(`${DASHBOARD_PATH}/`)) return true
	if (pathname === '/super' || pathname.startsWith('/super/')) return true
	if (pathname === '/admin' || pathname.startsWith('/admin/')) return true
	return false
}
